export const TypesVistoriaOEAAvarias = {
    SET_COMBOS_AVARIAS: "vistoriaOEAAvarias/SET_COMBOS_AVARIAS",
    TOGGLE_LOCAL: "vistoriaOEAAvarias/TOGGLE_LOCAL",
    TOGGLE_TIPO: "vistoriaOEAAvarias/TOGGLE_TIPO",
    TOGGLE_COMPLEMENTO: "vistoriaOEAAvarias/TOGGLE_COMPLEMENTO",
    TOGGLE_AVARIA_PARA_REMOVER: "vistoriaOEAAvarias/TOGGLE_AVARIA_PARA_REMOVER",
    ADICIONAR_AVARIAS: "vistoriaOEAAvarias/ADICIONAR_AVARIAS",
    REMOVER_AVARIAS_SELECIONADAS:
        "vistoriaOEAAvarias/REMOVER_AVARIAS_SELECIONADAS",
    RESETAR: "vistoriaOEAAvarias/RESETAR"
};

export const INITIAL = {
    locaisAvaria: [],
    tiposAvaria: [],
    complementosAvaria: [],
    locaisSelecionados: [],
    tiposSelecionados: [],
    complementosSelecionados: [],
    avarias: [],
    avariasParaRemover: []
};

const toggleId = (lista, id) =>
    lista.includes(id) ? lista.filter(x => x !== id) : [...lista, id];

export default function vistoriaOEAAvariasReducer(state = INITIAL, action) {
    switch (action.type) {
        case TypesVistoriaOEAAvarias.SET_COMBOS_AVARIAS:
            return {
                ...state,
                locaisAvaria: action.payload.Locais,
                tiposAvaria: action.payload.Tipos,
                complementosAvaria: action.payload.Complementos
            };

        case TypesVistoriaOEAAvarias.TOGGLE_LOCAL:
            return {
                ...state,
                locaisSelecionados: toggleId(
                    state.locaisSelecionados,
                    action.payload.id
                )
            };

        case TypesVistoriaOEAAvarias.TOGGLE_TIPO:
            return {
                ...state,
                tiposSelecionados: toggleId(
                    state.tiposSelecionados,
                    action.payload.id
                )
            };

        case TypesVistoriaOEAAvarias.TOGGLE_COMPLEMENTO:
            return {
                ...state,
                complementosSelecionados: toggleId(
                    state.complementosSelecionados,
                    action.payload.id
                )
            };

        case TypesVistoriaOEAAvarias.TOGGLE_AVARIA_PARA_REMOVER:
            return {
                ...state,
                avariasParaRemover: toggleId(
                    state.avariasParaRemover,
                    action.payload.chave
                )
            };

        case TypesVistoriaOEAAvarias.ADICIONAR_AVARIAS: {
            const { novas } = action.payload;
            const map = new Map(state.avarias.map(a => [a.descricao, a]));
            novas.forEach(a => map.set(a.descricao, a));
            return {
                ...state,
                avarias: Array.from(map.values()),
                locaisSelecionados: [],
                tiposSelecionados: [],
                complementosSelecionados: []
            };
        }

        case TypesVistoriaOEAAvarias.REMOVER_AVARIAS_SELECIONADAS:
            return {
                ...state,
                avarias: state.avarias.filter(
                    a => !state.avariasParaRemover.includes(a.chave)
                ),
                avariasParaRemover: []
            };

        case TypesVistoriaOEAAvarias.RESETAR:
            return INITIAL;

        default:
            return state;
    }
}

function setCombosAvarias(combos) {
    return { type: TypesVistoriaOEAAvarias.SET_COMBOS_AVARIAS, payload: combos };
}

function toggleLocal(id) {
    return { type: TypesVistoriaOEAAvarias.TOGGLE_LOCAL, payload: { id } };
}

function toggleTipo(id) {
    return { type: TypesVistoriaOEAAvarias.TOGGLE_TIPO, payload: { id } };
}

function toggleComplemento(id) {
    return {
        type: TypesVistoriaOEAAvarias.TOGGLE_COMPLEMENTO,
        payload: { id }
    };
}

function toggleAvariaParaRemover(chave) {
    return {
        type: TypesVistoriaOEAAvarias.TOGGLE_AVARIA_PARA_REMOVER,
        payload: { chave }
    };
}

function adicionarAvarias(novas) {
    return {
        type: TypesVistoriaOEAAvarias.ADICIONAR_AVARIAS,
        payload: { novas }
    };
}

function removerAvariasSelecionadas() {
    return { type: TypesVistoriaOEAAvarias.REMOVER_AVARIAS_SELECIONADAS };
}

function resetar() {
    return { type: TypesVistoriaOEAAvarias.RESETAR };
}

export const VistoriaOEAAvariasActions = {
    setCombosAvarias,
    toggleLocal,
    toggleTipo,
    toggleComplemento,
    toggleAvariaParaRemover,
    adicionarAvarias,
    removerAvariasSelecionadas,
    resetar
};
